const isRestockingSoon = (product) =>
  !!product?.restockingSoonDetails?.shouldShowRestockingSoon;

export default isRestockingSoon;
